import { render, staticRenderFns } from "./PlantGroup.vue?vue&type=template&id=4985ee43&scoped=true&"
import script from "./PlantGroup.vue?vue&type=script&lang=ts&"
export * from "./PlantGroup.vue?vue&type=script&lang=ts&"
import style0 from "./PlantGroup.vue?vue&type=style&index=0&id=4985ee43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985ee43",
  null
  
)

export default component.exports